import { Outlet } from 'react-router-dom';
import { CookieManager } from './CookieManager';

export const Content = () => {

  return (
    <div className={`relative flex h-screen min-h-screen flex-col overflow-hidden`}>
      <CookieManager>
          <Outlet />
      </CookieManager>
    </div>
  );
};
